<template>
    <div :class="classObj" class="app-wrapper" :style="{'--current-color': theme}">
        <Sidebar v-if="!sidebar.hide" class="sidebar-container"/>
        <div :class="{hasTagsView:needTagsView,sidebarHide:sidebar.hide}" class="main-container">
            <div :class="{'fixed-header':fixedHeader}" style="box-shadow: 0 1px 4px rgba(0,21,41,.08);">
                <navbar />
                <tags-view v-if="needTagsView" />
            </div>
            <app-main />
        </div>
    </div>
</template>

<script>
    import { AppMain, Navbar, Sidebar } from './components';
    import { mapGetters, mapState } from 'vuex';
    export default{
        components: { AppMain, Navbar, Sidebar },
        data() {
            return {
                socket: null,
            }
        },
        computed: {
            ...mapState({
                theme: state => state.settings.theme,
                sideTheme: state => state.settings.sideTheme,
                sidebar: state => state.app.sidebar,
                fixedHeader: state => state.settings.fixedHeader
            }),
            ...mapGetters(['employeeId','scope']),
            classObj() {
                return {
                    hideSidebar: !this.sidebar.opened,
                    openSidebar: this.sidebar.opened
                }
            },
        },
        
        
        mounted() {
        //     // 监听键盘按下事件
        //     window.addEventListener('keydown', this.handleKeyDown);
            if(this.employeeId !== '1'){
                this.sidebar.hide = true
            }
        },
        // beforeUnmount() {
        //     // 移除键盘事件监听
        //     window.removeEventListener('keydown', this.handleKeyDown);
        // },
        methods: {
            handleKeyDown(event) {
                // 检测是否是F5刷新键
                if (event.keyCode === 116) {
                    // 阻止默认行为，即不允许刷新
                    event.preventDefault();
                }
            }
        }
    }
</script>

<style lang="scss">
    @import "~@/assets/styles/mixin.scss";
    .app-wrapper {
        @include clearfix;
        position: relative;
        height: 100%;
        width: 100%;

        &.mobile.openSidebar {
        position: fixed;
        top: 0;
        }
    }
    .sidebar-container{
        box-shadow: 2px 0 6px rgba(0,21,41,.35);
    }
    .el-header {
        padding: 0;
        box-shadow: 0 1px 4px rgba(0,21,41,.08);
        .el-menu--horizontal.el-menu{
            border-bottom: 0;
        }
    }
    .el-main{
        padding: 0;
    }
</style>